import './index.css'

const LatestMatch = props => {
  const {latestMatchDetails} = props
  const {
    umpires,
    result,
    manOfTheMatch,
    date,
    venue,
    competingTeam,
    competingTeamLogo,
    firstInnings,
    secondInnings,
  } = latestMatchDetails

  return (
    <div className="boxes-container">
      <div className="latest-matches-card status-box">
        <div className="match-status-logo">
          <div className="match-status-section">
            <p className="competing-team">{competingTeam}</p>
            <p className="date">{date}</p>
            <p className="latest-match-heading">{venue}</p>
            <p className="latest-match-heading">{result}</p>
          </div>
          <img
            className="matches-logo"
            alt={`latest match ${competingTeam}`}
            src={competingTeamLogo}
          />
        </div>
      </div>
      <hr className="section-separator" />
      <div className="latest-matches-card detailed-box">
        <div className="match-detailed-section">
          <p className="latest-match-title">First Innings</p>
          <p className="latest-match-value">{firstInnings}</p>

          <p className="latest-match-title">Second Innings</p>
          <p className="latest-match-value">{secondInnings}</p>

          <p className="latest-match-title">Man of The Match</p>
          <p className="latest-match-value">{manOfTheMatch}</p>

          <p className="latest-match-title">Umpires</p>
          <p className="latest-match-value">{umpires}</p>
        </div>
      </div>
    </div>
  )
}

export default LatestMatch
